import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    &.column {
        flex-direction: column;
    }
    align-items: center;
    margin: 15px 0;
    ${({ marginTop = "15px" }) => {
        return `
            margin-top: ${marginTop};
        `;
    }}
    width: 100%;
    & svg {
        margin-bottom: 15px;
    }
    &.secondary path {
        &:nth-child(1), &:nth-child(2) {
            fill: var(--light-1);
        }
    }
    & h4, & p {
        margin: 0;
        margin-top: 10px;
        text-align: center;
    }
    &.row {
        justify-content: center;
        & p {
            margin-top: 0;
            margin-left: 40px;
            max-width: 350px;
        }
    }

`;